exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-variant-form-items__remove-button {\n  font-size: 12px;\n  line-height: 0;\n  padding: 6px;\n  position: absolute;\n  right: 0px;\n  top: 0;\n  z-index: 100;\n  width: auto;\n  display: inline-block;\n  cursor: pointer;\n}\n.product-variant-form-items__remove-button:hover {\n  color: #f7931e;\n}\n", ""]);

// exports
